import React from 'react'
import { Box, Typography } from '@mui/material'

interface Props {
    children: React.ReactNode
}

export const ActionText: React.VFC<Props> = ({ children }: Props) => (
    <Box
        sx={{
            m: 0,
            mt: 0.5,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        }}
    >
        <Typography sx={{ fontWeight: 'bold', textTransform: 'uppercase' }} variant="caption" color="primary">
            {children}
        </Typography>
    </Box>
)

export type { Props as ActionTextProps }
